var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dialog-create-task',{on:{"cancel":_vm.handleCancel,"done":_vm.handleDone}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }